<div class="ap-margin-bottom-3">{{ 'property.sustainability.amount' | coApplicantPipe: store.hasCoApplicant | apContent }}</div>

<ap-amount-input
    id="sustainabilityAmount"
    [helpText]="'property.sustainability-loan.help-text' | apContent"
    [showSymbol]="true"
    [numberOfDecimals]="0"
    [formControl]="mainApplicantControl"
></ap-amount-input>

<additional-info
    [key]="questionKey"
    titleKey="property.sustainability.amount.additional-info.text"
    contentKey="property.sustainability.amount.additional-info.content"
    modalUrlKey="property.sustainability.amount.additional-info.text"
></additional-info>

@if (!store.isSummary) {
    <next-button (click)="nextQuestion()"></next-button>
}
